/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FixedPriceContractLineRequest } from './';
import {
    FixedPriceContractLineRequestFromJSON,
    FixedPriceContractLineRequestFromJSONTyped,
    FixedPriceContractLineRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceContractDetailsRequest
 */
export interface FixedPriceContractDetailsRequest {
    /**
     * 
     * @type {Array<FixedPriceContractLineRequest>}
     * @memberof FixedPriceContractDetailsRequest
     */
    quoteLines?: Array<FixedPriceContractLineRequest>;
    /**
     * 
     * @type {string}
     * @memberof FixedPriceContractDetailsRequest
     */
    additionalNotes?: string;
}

/**
 * Check if a given object implements the FixedPriceContractDetailsRequest interface.
 */
export function instanceOfFixedPriceContractDetailsRequest(value: object): value is FixedPriceContractDetailsRequest {
    return true;
}

export function FixedPriceContractDetailsRequestFromJSON(json: any): FixedPriceContractDetailsRequest {
    return FixedPriceContractDetailsRequestFromJSONTyped(json, false);
}

export function FixedPriceContractDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceContractDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteLines': json['quoteLines'] == null ? undefined : ((json['quoteLines'] as Array<any>).map(FixedPriceContractLineRequestFromJSON)),
        'additionalNotes': json['additionalNotes'] == null ? undefined : json['additionalNotes'],
    };
}

export function FixedPriceContractDetailsRequestToJSON(value?: FixedPriceContractDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'quoteLines': value['quoteLines'] == null ? undefined : ((value['quoteLines'] as Array<any>).map((v) => FixedPriceContractLineRequestToJSON(v))),
        'additionalNotes': value['additionalNotes'],
    };
}

